import axiosInstance from '../helpers/axiosConfig';
import { createAsyncThunk } from "@reduxjs/toolkit";

export const login = createAsyncThunk(
    'auth/login',
    async ({ email, password }, { rejectWithValue }) => {
        const config = {
            headers: {
                'Content-Type': 'application/json',
            },
        };

        const body = JSON.stringify ({ email, password});

        try {
            const res = await axiosInstance.post('users/login', body, config)
            return res.data
        } catch (err) {
            return rejectWithValue(err.response.data)
        }
    }
)